import { type AxiosResponse } from 'axios';
import { get, put, post } from '@utilities';

export const fetchFCCosting = async (): Promise<AxiosResponse> => await get('costing/fc/all');
export const editFCCosting = async (data: Record<string, any> | Array<Record<string, any>>): Promise<AxiosResponse> =>
	await put('costing/fc', data);
export const fetchFCLumenCosting = async (): Promise<AxiosResponse> => await get('costing/lumen/all');
export const editFCLumenCosting = async (
	data: Record<string, any> | Array<Record<string, any>>
): Promise<AxiosResponse> =>
	await put('costing/lumen', data);

export const fetchFCMaterialCosting = async (): Promise<AxiosResponse> => await get('costing/fc-material/all');
export const editFCMaterialCosting = async (
	data: Record<string, any> | Array<Record<string, any>>
): Promise<AxiosResponse> =>
	await put('costing/fc-material', data);
export const addFCMaterialCosting = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await post('costing/fc-material', data);

export const fetchCabinetMaterials = async (type: string): Promise<AxiosResponse> =>
	await get(`cabinet/materials?type=${type}`);
export const editCabinetMaterials = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('cabinet/materials', data);

export const fetchCounterTopMaterials = async (): Promise<AxiosResponse> => await get('countertop/all');
export const editCounterTopMaterials = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('countertop/update', data);

export const fetchWallTiles = async (): Promise<AxiosResponse> => await get('tiles');
export const updateWallTile = async (data: Record<string, any> | Array<Record<string, any>>): Promise<AxiosResponse> =>
	await put('tiles', data);
export const addWallTile = async (data: Record<string, any>): Promise<AxiosResponse> => await post('tiles', data);

export const fetchElectricalModules = async (): Promise<AxiosResponse> => await get('electrical/materials');
export const editElectricalModules = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('electrical/materials', data);

export const fetchPaintMaterials = async (): Promise<AxiosResponse> => await get('paint/materials');
export const editPaintMaterials = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('paint/materials', data);

export const fetchPaintV2Materials = async (): Promise<AxiosResponse> => await get('paint/v2/materials');
export const editPaintV2Materials = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('paint/v2/materials', data);
export const fetchPaintV2LabourRates = async (): Promise<AxiosResponse> => await get('paint/v2/labour-rates');
export const editPaintV2LabourRates = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('paint/v2/labour-rates', data);

export const fetchMouldingTypes = async (): Promise<AxiosResponse> => await get('moulding/types');
export const fetchMouldingPatterns = async (): Promise<AxiosResponse> => await get('moulding/patterns');

export const editMouldingTypes = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('moulding/types', data);
export const editMouldingPatterns = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('moulding/patterns', data);

export const fetchSFBMaterials = async (): Promise<AxiosResponse> => await get('materials/sfb');
export const editSFBMaterials = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await put('materials/sfb', data);

export const fetchCurtainMaterials = async (): Promise<AxiosResponse> => await get('curtain/materials');
export const editCurtainMaterials = async (data: any): Promise<AxiosResponse> => await put('curtain/materials', data);

export const fetchBuilderChargeConfigs = async (builderUsage?: string): Promise<AxiosResponse> =>
	await get(`dynamic-costing/builder-charge-config/${builderUsage || 'all'}`);
export const upsertBuilderChargeConfig = async (data: Record<string, any>): Promise<AxiosResponse> =>
	await post('dynamic-costing/builder-charge-config', data);
